export default function Image({ config, ...props }) {
  return <img src={config.path} style={config.style || {}} className={config.animation && 'animation-'+config.animation} {...props} />;
}
